import React, { useState, useEffect, useRef } from 'react';
import { getActivities } from '../../services/api';

export default function ActivityPickerModal({ config, onSelect, onClose }) {
  const [activities, setActivities] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const searchRef = useRef();

  useEffect(() => {
    if (searchRef.current) searchRef.current.focus();
    const cropId = config?.lot?.crop_id;
    if (!cropId) {
      setError('No se encontró el cultivo del lote seleccionado');
      setLoading(false);
      return;
    }
    getActivities(config.areaId, config.businessUnitId, cropId)
      .then(data => {
        const list = Array.isArray(data) ? data : data.data || [];
        setActivities(list);
        setFiltered(list);
      })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, [config]);

  useEffect(() => {
    const q = search.toLowerCase();
    setFiltered(activities.filter(a =>
      (a.name || a.activity_name || '').toLowerCase().includes(q)
    ));
  }, [search, activities]);

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal-box" style={{ maxWidth: 460 }}>
        <div className="modal-header">
          <h2>Seleccionar Actividad</h2>
          <button className="btn btn-ghost btn-sm" onClick={onClose} style={{ padding: '4px 8px' }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        <div className="modal-body">
          {/* Search */}
          <div style={{ position: 'relative', marginBottom: 16 }}>
            <svg
              width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
              style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)' }}
            >
              <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
            <input
              ref={searchRef}
              className="input-field"
              style={{ paddingLeft: 36 }}
              placeholder="Buscar actividad..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>

          {/* List */}
          {loading && (
            <div style={{ display: 'flex', justifyContent: 'center', padding: 32 }}>
              <div className="spinner" />
            </div>
          )}
          {error && <div className="alert alert-error">{error}</div>}
          {!loading && !error && (
            <div style={{ maxHeight: 320, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 4 }}>
              {filtered.length === 0 && (
                <div style={{ textAlign: 'center', color: 'var(--text-muted)', padding: '24px 0', fontSize: 13 }}>
                  No se encontraron actividades
                </div>
              )}
              {filtered.map(a => (
                <button
                  key={a.id}
                  type="button"
                  onClick={() => onSelect(a)}
                  style={{
                    padding: '10px 14px',
                    background: '#fff',
                    border: '1px solid var(--border)',
                    borderRadius: 'var(--radius)',
                    cursor: 'pointer',
                    textAlign: 'left',
                    fontFamily: 'var(--font-main)',
                    color: 'var(--text-primary)',
                    fontSize: 13,
                    transition: 'var(--transition)',
                  }}
                  onMouseEnter={e => {
                    e.currentTarget.style.borderColor = 'var(--accent)';
                    e.currentTarget.style.background = 'var(--accent-glow)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.borderColor = 'var(--border)';
                    e.currentTarget.style.background = 'var(--bg-primary)';
                  }}
                >
                  <div style={{ fontWeight: 500 }}>{a.name || a.activity_name}</div>
                  {a.category_name && (
                    <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>{a.category_name}</div>
                  )}
                </button>
              ))}
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}
